import React, { useCallback, useEffect, useState } from 'react';
import InputSelect from '../../../../component/inputSelect/InputSelect';
import InputField from '../../../../component/form/FormInput';
import { fetchVendors } from '../../../../services/vendor';
import OrderTable from '../../OrderTable';
import { toast } from 'react-toastify';
import tooltipIcon from '../../../../assets/image/tooltip_vendor name.png';
import OpenPOAlert from '../../../../assets/image/Open PO Alert.svg';
import settingIcon from '../../../../assets/image/settings2.svg';
import EmailCommunication from '../EmailCommunication/EmailCommunication';
import {
	addDeliveryMethod,
	fetchPurchaseOrderNumber,
	fetchPurchaseOrders,
	getDeliveryMethod,
} from '../../../../services/purchaseOrder';
import Modal from '../../../../component/modal/Modal';
import Button from '../../../../component/ui/Button';
import Configure from '../../../../component/Configure/Configure';
import AddVendorModal from '../../AddNewVendor';
import VendorDetailsDrawer from '../VendorDetailsDrawer';
import { getDate } from '../../../../utils/dateUtils';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getProductDetails } from '../../../../services/products';

function PurchaseOrderForm({
	id,
	formData,
	setFormData,
	handleFormData,
	handleSavePurchaseOrder,
	disabled,
	paramId,
	tableError,
	error,
	setErrorCells,
	errorCells,
	setError,
	setIsTableErrorShow,
	communicationEmail,
	setCommunicationEmail,
}) {
	const userDetails = useSelector((state) => state?.userInfo?.userInfo);
	const [isAddNewDeliveryMethodOpen, setIsAddNewDeliveryMethodOpen] = useState(false);
	const [addNewDeliveryMethod, setAddNewDeliveryMethod] = useState('');
	const [isVendorDetailsDrawerOpen, setIsVendorDetailsDrawerOpen] = useState(false);
	const [vendorDetailsDrawerActiveOpenTab, setVendorDetailsDrawerActiveOpenTab] = useState('');
	const [isConfigurePurchaseOrderModalOpen, setIsConfigurePurchaseOrderModalOpen] = useState(false);
	const [isAddNewVendorModalOpen, setIsAddNewVendorModalOpen] = useState(false);
	const [isAutoGeneratedPurchaseOrder, setIsAutoGeneratedPurchaseOrder] = useState(true);
	const [isAutoGeneratedPONumberUpdated, setIsAutoGeneratedPONumberUpdated] = useState(false);
	const [isOpenPastDate, setIsOpenPastDate] = useState(false);
	const [isUsedPastDate, setIsUsedPastDate] = useState(false);
	const [autofocus, setAutofocus] = useState(false);
	const today = new Date();
	const location = useLocation();
	const formattedDate = today.toISOString().split('T')[0];
	const [currentDate, setCurrentDate] = useState(formattedDate);
	const [isDeliveryAddressFocus, setIsDeliveryAddressFocus] = useState(false);
	const [vendorDetails, setVendorDetails] = useState({});
	const [projectTitle, setProjectTitle] = useState('Create New Purchase Order');
	const [params, setParams] = useState({
		vendor: {
			status: 1,
			filterBy: null,
			filterValue: null,
			filter: {
				status: '1',
			},
		},
		deliver_method: {
			filterBy: null,
			filterValue: null,
		},
	});
	const [dropdownList, setDropdownList] = useState({
		vendors: [],
		delivery_methods: [],
	});
	const [search, setSearch] = useState({
		vendor: '',
		delivery_method: '',
	});

	const confirmUsedPastDate = () => {
		const newError = { ...error };
		delete newError.date;
		setError(newError);
		setIsUsedPastDate(true);
		setIsOpenPastDate(false);
		setIsDeliveryAddressFocus(true);
	};

	const cancelUsedPastDate = () => {
		setIsOpenPastDate(false);
		setIsDeliveryAddressFocus(true);
	};

	const checkFormValidation = (type, value) => {
		let newError = { ...error };
		if (value) {
			if (type === 'vendor_id' && value !== null && value !== '') {
				delete newError.vendor_id;
			}
			if (type === 'purchase_order_number' && value !== '' && value !== null) {
				delete newError.purchase_order_number;
			}
			if (type === 'date') {
				delete newError.date;
			}
		} else {
			if (type === 'vendor_id' && (value === null || value === '')) {
				newError.vendor_id = 'Please select a valid vendor from the list.';
			}
			if (type === 'purchase_order_number' && (value === '' || value === null)) {
				newError.purchase_order_number = 'Please enter purchase order number in the field';
			}
			if (type === 'date' && (value === '' || value === null)) {
				newError.date = 'Please enter date in the field';
			}
		}
		setError(newError);
	};

	const handleKeyDown = (name, event) => {
		let { value } = event.target;
		if (event.key === 'Enter' && event.key === 'Tab') {
			handleFormData(name, value);
			checkFormValidation(name, value);
		}
	};

	//TODO: Add Delivery method
	//TODO: Create new delivery method set to form data and into deliveryMethod list and auto select to delivery method
	async function handleAddNewDeliveryMethodFrom() {
		const body = {
			method_name: addNewDeliveryMethod,
		};
		const deliveryMethod = await addDeliveryMethod(body);
		setDropdownList((prev) => ({
			...prev,
			delivery_methods: [
				{ key: deliveryMethod?.method_name, value: deliveryMethod?.method_name },
				...prev.delivery_methods,
			],
		}));
		setIsAddNewDeliveryMethodOpen(false);
		setAddNewDeliveryMethod('');
		handleFormData('delivery_method', deliveryMethod?.method_name);
	}

	const handleFetchPurchaseOrdersByVendorId = useCallback(async () => {
		try {
			if (formData?.vendor_id === null || formData?.vendor_id === '') return;

			const { vendors } = await fetchVendors({
				filterBy: 'vendor_id',
				filterValue: formData.vendor_id,
				status: 1,
			});

			const vendor = vendors[0];

			if (vendor?.contact_person) {
				const emails = vendor.contact_person.reduce((acc, contact) => {
					if (contact?.email) {
						acc.push({
							id: contact?.contact_person_id,
							email: contact?.email,
							salutation: contact?.salutation,
							first_name: contact.first_name,
							last_name: contact.last_name,
							mobile: contact?.mobile,
							work_phone: contact?.work_phone,
							department: contact?.department,
						});
					}
					return acc;
				}, []);

				handleFormData(
					'email_communication',
					emails.filter((email) => email.isSelected).map((e) => e.email),
				);

				if (emails.length > 0) {
					const mappedEmails = emails.map((email) => ({
						...email,
						isSelected: true,
					}));

					setCommunicationEmail(mappedEmails);
				}
			}
			setVendorDetails(vendor);

			const isVendorPresent = dropdownList?.vendors?.find((v) => v.vendor_id === vendor?.vendor_id);

			if (!isVendorPresent) {
				const updateVendorList = [
					{ key: vendor?.vendor_id, value: vendor?.vendor_name },
					...dropdownList?.vendors,
				];
				setDropdownList((prev) => ({
					...prev,
					vendors: updateVendorList,
				}));
			}
		} catch (error) {
			toast.error('Something went wrong!');
		}
	}, [formData?.vendor_id]);

	useEffect(() => {
		if (formData.vendor_id || id) {
			handleFetchPurchaseOrdersByVendorId();
		}
	}, [formData.vendor_id, id]);

	async function handleFetchPurchaseOrderDetails() {
		try {
			const params = {
				filterBy: 'purchase_order_id',
				filterValue: id,
			};
			const purchaseOrderDetails = await fetchPurchaseOrders(params);
			const purchaseDetails = purchaseOrderDetails.purchaseOrders[0];
			const {
				vendor_id,
				purchase_order_number,
				date,
				delivery_address,
				expected_delivery_date,
				delivery_method,
				is_draft,
				payment_terms,
				purchase_order_products,
				remarks,
				vendor,
			} = purchaseDetails;

			setFormData({
				vendor_id,
				purchase_order_number,
				date: getDate(date, true),
				delivery_address,
				expected_delivery_date:
					expected_delivery_date !== null && expected_delivery_date !== ''
						? getDate(expected_delivery_date, true)
						: '',
				delivery_method,
				is_draft,
				payment_terms,
				purchase_order_products: purchase_order_products || [],
				email_communication:
					vendor?.contact_person?.length > 0
						? vendor?.contact_person?.map((contact) => contact?.email)
						: [],
				remarks,
			});
			setParams((prev) => ({
				...prev,
				vendor: {
					...prev.vendor,
					filterBy: 'vendor_id',
					filterValue: vendor?.vendor_id,
				},
				deliver_method: {
					...prev.deliver_method,
					filterBy: 'method_name',
					filterValue: delivery_method,
				},
			}));
		} catch (error) {
			toast.error('Something went wrong!');
		}
	}

	const handleFetchVendorList = useCallback(async () => {
		try {
			const { vendors } = await fetchVendors(params.vendor);
			const vendorOptionList = vendors?.map((vendor) => {
				return {
					key: vendor?.vendor_id,
					value: vendor?.vendor_name,
				};
			});
			if (formData?.vendor_id) {
				const isVendorFound = vendorOptionList.find((method) => method.key === formData?.vendor_id);
				if (!isVendorFound) {
					setParams((prev) => ({
						...prev,
						vendor: {
							filterBy: 'vendor_id',
							filterValue: formData?.vendor_id,
						},
					}));
				}
			} else {
				setDropdownList((prev) => ({
					...prev,
					vendors: vendorOptionList,
				}));
			}
		} catch (error) {
			toast.error('Something went wrong!');
		}
	}, [params?.vendor]);

	useEffect(() => {
		if (!formData.vendor_id) {
			handleFetchVendorList();
		}
	}, [params?.vendor, id, formData.vendor_id]);

	useEffect(() => {
		let timer = setTimeout(() => {
			setParams((prev) => ({
				...prev,
				vendor: {
					...prev.vendor,
					filterBy: 'vendor_name',
					filterValue: search?.vendor,
				},
			}));
		}, 500);
		return () => clearTimeout(timer);
	}, [search.vendor]);

	const handleSearchDeliveryMethod = useCallback(async () => {
		try {
			const data = await getDeliveryMethod(params.deliver_method);
			const deliveryMethodOptionList = data.map((delivery) => {
				return {
					key: delivery?.method_name,
					value: delivery?.method_name,
				};
			});
			if (formData?.delivery_method) {
				const isVendorFound = deliveryMethodOptionList.find(
					(method) => method.key === formData?.delivery_method,
				);
				if (!isVendorFound) {
					setParams((prev) => ({
						...prev,
						deliver_method: {
							filterBy: 'method_name',
							filterValue: formData?.delivery_method,
						},
					}));
				}
			} else {
				setDropdownList((prev) => ({
					...prev,
					delivery_methods: deliveryMethodOptionList,
				}));
			}
		} catch (error) {
			toast.error('Something went wrong while searching for delivery method! ' + error);
		}
	}, [params.deliver_method]);

	useEffect(() => {
		let timer = setTimeout(() => {
			setParams((prev) => ({
				...prev,
				deliver_method: {
					filterBy: 'method_name',
					filterValue: search?.delivery_method,
				},
			}));
		}, 500);
		return () => clearTimeout(timer);
	}, [search.delivery_method]);

	function setVendorData() {
		if (location && location?.state) {
			const state = location?.state;
			setDropdownList((prev) => ({
				...prev,
				vendors: [{ key: Number(state.key), value: state.value }],
			}));
			setFormData((prev) => ({
				...prev,
				vendor_id: Number(state?.key),
			}));
		}
	}
	const setProductList = () => {
		if (location && location?.state && location.state?.products?.length > 0) {
			const newData = location.state?.products.map((item) => ({
				product_id: item.id,
				product_packaging: item.packaging,
				order_quantity: null,
			}));
			handleFormData('purchase_order_products', newData);
		}
	};

	useEffect(() => {
		if (location && location?.state && location.state?.products?.length > 0) {
			setProductList();
		} else if (location && location?.state) {
			setVendorData();
		}
	}, [location]);

	useEffect(() => {
		handleSearchDeliveryMethod();
	}, [params.deliver_method]);

	const handlePurchaseOrderNumber = useCallback(async () => {
		try {
			const purchaseOrderNumber = await fetchPurchaseOrderNumber();
			handleFormData('purchase_order_number', purchaseOrderNumber);
		} catch (error) {
			toast.error('Something went wrong!');
		}
	}, [userDetails?.data?.userData?.is_auto_generated_purchase_order_number_enabled]);

	useEffect(() => {
		if (id && !id.includes('product_id')) {
			handleFetchPurchaseOrderDetails();
			setProjectTitle('Update Purchase Order');
		}
		if (
			(!id || id.includes('product_id')) &&
			userDetails?.data?.userData?.is_auto_generated_purchase_order_number_enabled &&
			!isAutoGeneratedPONumberUpdated
		) {
			handlePurchaseOrderNumber();
		}
	}, [id, userDetails]);

	useEffect(() => {
		if (userDetails) {
			setIsAutoGeneratedPurchaseOrder(
				userDetails?.data?.userData?.is_auto_generated_purchase_order_number_enabled,
			);
		}
	}, [userDetails]);

	useEffect(() => {
		if (!autofocus) {
			setAutofocus(true);
		}
	}, [autofocus]);

	useEffect(() => {
		document.title = `${projectTitle} | Pharmnex`;
	}, [projectTitle]);

	// TODO to fetch the purchase order products from notifications

	const getProduct = async (productId) => {
		try {
			var { product_id, packaging } = await getProductDetails(productId);
			var newData = [
				{
					product_id: product_id,
					product_packaging: packaging.name,
					order_quantity: null,
				},
			];
			handleFormData('purchase_order_products', newData);
		} catch (e) {}
	};

	useEffect(() => {
		if (id && id.includes('product_id')) {
			var productId = id.split('=')[1];
			getProduct(productId);
		}
	}, []);

	return (
		<div>
			<div
				className="max-w-1297"
				style={{ padding: '1rem 2rem 0' }}
			>
				<div className="row">
					<div className="col-6">
						<InputSelect
							options={dropdownList.vendors}
							label="Vendor Name"
							placeholder="Vendor Name"
							required={true}
							onKeyDown={(e) => handleKeyDown('vendor_id', e)}
							error={error?.vendor_id}
							value={formData?.vendor_id}
							returnInputValue={false}
							onChange={(value) => {
								if (value === '') {
									checkFormValidation('vendor_id', '');
									handleFormData('vendor_id', '');
									handleFormData('email_communication', []);
									setCommunicationEmail([]);
									handleFetchVendorList();
								}
								setSearch((prev) => ({
									...prev,
									vendor: value,
								}));
							}}
							onSelect={(option) => {
								handleFormData('vendor_id', option.key);
								checkFormValidation('vendor_id', option.key);
							}}
							autoFocus={autofocus}
							onAddNew={() => setIsAddNewVendorModalOpen(true)}
							className="labelClass"
							leftIcons={
								formData?.vendor_id && [
									{
										src: OpenPOAlert,
										alt: 'showVendorDetails',
										onClick: () => {
											setVendorDetailsDrawerActiveOpenTab('Open POs');
											setIsVendorDetailsDrawerOpen(true);
										},
									},
									{
										src: tooltipIcon,
										alt: 'Icon 2',
										onClick: () => {
											setVendorDetailsDrawerActiveOpenTab('Details');
											setIsVendorDetailsDrawerOpen(true);
										},
									},
								]
							}
						/>
					</div>
					<div className="col-3">
						<InputField
							label="Purchase Order #"
							placeholder="Purchase Order Number"
							type="text"
							required={true}
							error={error?.purchase_order_number}
							value={formData.purchase_order_number}
							onChange={(value) => {
								handleFormData('purchase_order_number', value);
								checkFormValidation('purchase_order_number', value);
							}}
							disabled={isAutoGeneratedPurchaseOrder}
							rightIcon={{
								src: settingIcon,
								alt: 'Purchase order configure icon',
								onClick: () => setIsConfigurePurchaseOrderModalOpen(true),
							}}
						/>
					</div>
					<div className="col-3">
						<InputField
							label="Date"
							placeholder="Enter Date"
							type="date"
							required={true}
							error={error?.date}
							value={formData.date}
							onBlur={(e) => {
								var value = e.target.value;
								const newError = { ...error };
								var date = new Date(value);
								var currentDate = new Date();
								currentDate.setDate(currentDate.getDate() + 1);
								let year = date.getFullYear().toString();
								if (year.length === 4 && new Date(value) < new Date().setHours(0, 0, 0, 0)) {
									if (!isUsedPastDate) {
										setIsOpenPastDate(true);
										newError.date = 'Date cannot be in the past.';
										setError(newError);
									} else {
										delete newError.date;
										setError(newError);
									}
									handleFormData('date', value);
								} else if (
									year.length === 4 &&
									new Date(value) > currentDate.setHours(0, 0, 0, 0)
								) {
									setIsOpenPastDate(false);
									newError.date = 'Date cannot be in the future';
									setError(newError);
									handleFormData('date', value);
								} else {
									setIsOpenPastDate(false);
									delete newError.date;
									setError(newError);
									handleFormData('date', value);
								}
							}}
							onChange={(value) => {
								handleFormData('date', value);
							}}
							max={currentDate}
						/>
					</div>
				</div>
				<div className="row">
					<div className="col-7">
						<InputField
							autoFocus={isDeliveryAddressFocus}
							label="Delivery Address"
							placeholder="Delivery Address"
							onKeyPress={(e) => handleKeyDown('delivery_address', e)}
							type="text"
							error={error?.delivery_address}
							returnInputValue={true}
							value={formData.delivery_address}
							onChange={(value) => handleFormData('delivery_address', value)}
						/>
					</div>

					<div className="col-5">
						<InputField
							label="Expected delivery Date"
							placeholder="expected delivery Date"
							type="date"
							min={currentDate}
							error={error?.expected_delivery_date}
							value={formData.expected_delivery_date}
							onBlur={(e) => {
								const value = e.target.value;
								const newError = { ...error };
								const selectedDate = new Date(value);
								const today = new Date();
								today.setHours(0, 0, 0, 0);

								if (value && selectedDate < today) {
									newError.expected_delivery_date = 'Expected Delivery Date cannot be in the past.';
									setError(newError);
								} else {
									delete newError.expected_delivery_date;
									setError(newError);
								}
							}}
							onChange={(value) => {
								handleFormData('expected_delivery_date', value);
							}}
						/>
					</div>
				</div>
				<div className="row">
					<div className="col-6">
						<InputField
							label="Reference #"
							placeholder="Reference #"
							type="text"
							error={error?.remarks}
							value={formData.remarks}
							onChange={(value) => handleFormData('remarks', value)}
						/>
					</div>
					<div className="col-6">
						<InputSelect
							options={dropdownList?.delivery_methods}
							onAddNew={() => setIsAddNewDeliveryMethodOpen(true)}
							label="Delivery Methods"
							placeholder="Delivery Methods"
							error={error?.delivery_method}
							returnInputValue={false}
							value={formData.delivery_method}
							onChange={(value) =>
								setSearch((prev) => ({
									...prev,
									delivery_method: value,
								}))
							}
							onSelect={(options) => handleFormData('delivery_method', options.value)}
						/>
					</div>
				</div>
			</div>

			{/* Purchase order Table */}
			<OrderTable
				id={id}
				tableData={formData.purchase_order_products}
				setTableData={handleFormData}
				handleSavePurchaseOrder={handleSavePurchaseOrder}
				disabled={disabled}
				setErrorCells={setErrorCells}
				errorCells={errorCells}
				paramId={paramId}
				tableError={tableError}
				setIsTableErrorShow={setIsTableErrorShow}
			/>

			<EmailCommunication
				formData={formData}
				communicationEmail={communicationEmail}
				setCommunicationEmail={setCommunicationEmail}
				handleFormData={handleFormData}
			/>

			{isAddNewDeliveryMethodOpen && (
				<Modal
					className="delivery-modal"
					title="Add New Delivery Method"
					isOpen={isAddNewDeliveryMethodOpen}
					onClose={() => setIsAddNewDeliveryMethodOpen(false)}
					cancelButton={true}
				>
					<div>
						<InputField
							placeholder="Add New Delivery method"
							value={addNewDeliveryMethod}
							onChange={(value) => {
								setAddNewDeliveryMethod(value);
							}}
						/>
						<br />
						<Button
							button="Add"
							type="button"
							className="btn btn-primary"
							onClick={handleAddNewDeliveryMethodFrom}
						/>
					</div>
				</Modal>
			)}
			{isOpenPastDate && (
				<Modal
					className="delivery-modal"
					title="Confirm Past Date"
					isOpen={isOpenPastDate}
					onClose={() => cancelUsedPastDate()}
					cancelButton={true}
				>
					<p>You are creating a transaction in the past date. Do you want to continue?</p>

					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'flex-start',
							marginTop: '20px',
						}}
					>
						<Button
							button="Proceed"
							type="button"
							className="btn btn-primary"
							onClick={confirmUsedPastDate}
						/>
						<span style={{ width: '20px' }}></span>
						<Button
							button="Cancel"
							type="button"
							className="btn btn-danger"
							onClick={() => cancelUsedPastDate()}
						/>
					</div>
				</Modal>
			)}

			{isConfigurePurchaseOrderModalOpen && (
				<Configure
					formData={formData}
					handleFormData={handleFormData}
					isAutoGeneratedPurchaseOrder={isAutoGeneratedPurchaseOrder}
					setIsAutoGeneratedPurchaseOrder={setIsAutoGeneratedPurchaseOrder}
					setIsAutoGeneratedPONumberUpdated={setIsAutoGeneratedPONumberUpdated}
					isConfigurePurchaseOrderModalOpen={isConfigurePurchaseOrderModalOpen}
					is_auto_generated_purchase_order_number_enabled={
						userDetails?.data?.userData?.is_auto_generated_purchase_order_number_enabled
					}
					setIsConfigurePurchaseOrderModalOpen={setIsConfigurePurchaseOrderModalOpen}
				/>
			)}

			{isAddNewVendorModalOpen && (
				<AddVendorModal
					handleFormData={handleFormData}
					vendorList={dropdownList.vendors}
					setVendorList={(value) =>
						setDropdownList((prev) => ({
							...prev,
							vendors: value,
						}))
					}
					onClose={() => setIsAddNewVendorModalOpen(false)}
				/>
			)}

			{
				<VendorDetailsDrawer
					isOpen={isVendorDetailsDrawerOpen}
					onClose={() => setIsVendorDetailsDrawerOpen(false)}
					vendor_id={formData.vendor_id}
					vendorDetailsDrawerActiveOpenTab={vendorDetailsDrawerActiveOpenTab}
				/>
			}
		</div>
	);
}

export default PurchaseOrderForm;
